import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Carousel.css";
import { images } from "./CarouselImages";
import { BiLogoFacebookCircle, BiLogoInstagramAlt } from "react-icons/bi";
import { Message } from "../Message/Message";

export const Carousel = () => {
  const scrollToSection = (e) => {
    e.preventDefault();
    const section = document.getElementById("quienessomos");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const settings = {
    fade: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <section id="carousel" className="carousel">
       <Message />
      <div className="carousel-items">
        <p className="carousel-items--text">VERDIVIA</p>
        <div className="carousel-items--icons">
          <a
            href="https://www.facebook.com/people/verdiviamza/100069458418428/"
            target="_blank"
            rel="noreferrer"
          >
            <BiLogoFacebookCircle className="carousel-items--icons-icon" />
          </a>
          <a
            href="https://www.instagram.com/verdivia.mza/"
            target="_blank"
            rel="noreferrer"
          >
            <BiLogoInstagramAlt className="carousel-items--icons-icon" />
          </a>
        </div>
        <a
          href="#quienessomos"
          className="carousel-items--btn"
          onClick={(e) => scrollToSection(e)}
        >
          Conocenos
        </a>
      </div>
      <Slider {...settings}>
        {images.map((image) => (
          <div key={image.id}>
            <img
              src={image.source}
              alt={`Slide ${image.id}`}
              className="carousel-img"
            />
          </div>
        ))}
      </Slider>
    </section>
  );
};
